import { useLoaderData, useLocation } from 'react-router';
import { dsClass } from '../../../common/constants/dsClasses.js';
import { InvitationLandingExpiredPage } from '../../../components/InvitationLandingPage/InvitationLandingExpiredPage.js';
import { InvitationLandingPage } from '../../../components/InvitationLandingPage/InvitationLandingPage.js';
import { PreAuthHeader } from '../../../components/PreAuthHeader/PreAuthHeader.js';
import { type InvitationLanding, InvitationProfileEnum } from '../../../generated/api/models.js';

export const InvitationLandingPath = () => {
  const location = useLocation();
  const { individualDetails } = location.state ?? {};
  const invitationData = useLoaderData<InvitationLanding>();

  if (!invitationData) {
    return (
      <div
        id="elisaid-invitation-landing-parent"
        className={`of-invitation-landing__path ${dsClass.BACKGROUND_COLOR_NEUTRAL_200} ${dsClass.MARGIN_0}`}
      >
        <div id="elisaid-invitation-landing-parent" className={`of-invitation-landing__path ${dsClass.MARGIN_0}`}>
          <PreAuthHeader isEoe={false} individualDetails={individualDetails} isPublic={true} />
          <InvitationLandingExpiredPage />
        </div>
      </div>
    );
  }

  return (
    <div
      id="elisaid-invitation-landing-parent"
      className={`of-invitation-landing__path ${dsClass.BACKGROUND_COLOR_NEUTRAL_200} ${dsClass.MARGIN_0}`}
    >
      <PreAuthHeader
        isEoe={invitationData.profile === InvitationProfileEnum.CUSTOMER_EMPLOYEE}
        individualDetails={individualDetails}
        isPublic={true}
      />
      <InvitationLandingPage invitationData={invitationData} />
    </div>
  );
};
